// extracted by mini-css-extract-plugin
module.exports = {"columnList":"SharesTools_columnList__MJcn3","title":"SharesTools_title__vFR3Z","column":"SharesTools_column__NM1f2"};